import React, { useState } from 'react';
import Home from '../components/Home';
import CountrySelector from '../components/CountrySelector';
import MenuSection from '../components/MenuSection';
import SearchBar from '../components/SearchBar';
import Contact from '../components/Contact';
import { FOOD_DATA } from '../data/foodData';

const HomePage = () => {
    const [activeCountry, setActiveCountry] = useState('All');
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedCategory, setSelectedCategory] = useState(null);

    const filteredItems = FOOD_DATA.filter(item => {
        const matchesCountry = activeCountry === 'All' || item.country === activeCountry;
        const matchesSearch = item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.description.toLowerCase().includes(searchQuery.toLowerCase());
        return matchesCountry && matchesSearch;
    });

    const handleCountrySelect = (countryName) => {
        const newCountry = activeCountry === countryName ? 'All' : countryName;
        setActiveCountry(newCountry);
        // When a country is selected, show all items for that country (effectively switching to the dish view)
        setSelectedCategory('Main Dishes'); // Default to showing dishes for that country

        // Smooth scroll to results
        setTimeout(() => {
            document.getElementById('menu').scrollIntoView({ behavior: 'smooth' });
        }, 100);
    };

    return (
        <div className="home-page">
            <Home />

            <CountrySelector
                activeCountry={activeCountry}
                onSelect={handleCountrySelect}
            />

            <SearchBar onSearch={setSearchQuery} />

            <MenuSection
                items={filteredItems}
                searchQuery={searchQuery}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
            />

            <Contact />
        </div>
    );
};

export default HomePage;
